import {debounce} from "../tools/tools";


export default class hideSocial {

    constructor() {

        this.floatingSocial = document.querySelector('.cp-share-social');
        if(!this.floatingSocial) return

        if(!this.floatingSocial) {
            return
        }

        this.floatingCTA = document.querySelector('.social-container');

        let observer = new IntersectionObserver((item) => {
           if(item[0].isIntersecting) {
                this.floatingSocial.classList.add("hide")
           }else
            this.floatingSocial.classList.remove("hide")

        })

        observer.observe(this.floatingCTA)
    }

}